module.exports = __webpack_public_path__ + "img/AU.6dfa6d29.svg";